import { render, staticRenderFns } from "./TaxSettings.vue?vue&type=template&id=5cc4ff2c&scoped=true"
import script from "./TaxSettings.vue?vue&type=script&lang=js"
export * from "./TaxSettings.vue?vue&type=script&lang=js"
import style0 from "./TaxSettings.vue?vue&type=style&index=0&id=5cc4ff2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc4ff2c",
  null
  
)

export default component.exports